import styled from 'styled-components';
import PcMoneyIcon from '@/assets/pc/PcMoney.svg?react';
import ArrowWhiteIcon from '@/assets/mo/ArrowWhite.svg?react';

const AssignSection = () => {
  return (
    <SectionWrapper>
      <ContentWrapper>
        <LeftBox>
          <PcMoneyIcon />
        </LeftBox>

        <RightBox>
          <TextGroup>
            <Title>현장심사 안내를 받았다면,</Title>
            <HighlightTitle>무료선임 신청하세요</HighlightTitle>
            <Description>보험사가 대신 지불하는 30만원 선임비용 혜택</Description>
          </TextGroup>

          <ApplyButton onClick={() => (window.location.href = '/appointment')}>
            <ButtonInner>
              <ButtonText>신청하기</ButtonText>
              <ArrowWhiteIcon />
            </ButtonInner>
          </ApplyButton>
        </RightBox>
      </ContentWrapper>
    </SectionWrapper>
  );
};

export default AssignSection;

// ================== Styled Components ==================

const SectionWrapper = styled.section`
  display: flex;
  align-items: center;
  justify-content: center; // ✅ 좌우 가운데 정렬
  background: #fff;

  @media (max-width: 900px) {
    flex-direction: column;
    padding: 40px 20px;
    gap: 40px;
  }
`;

const ContentWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 209px;

  @media (max-width: 900px) {
    flex-direction: column;
    gap: 32px;
  }
`;

const LeftBox = styled.div`
  display: flex;
  height: 580px;

  justify-content: flex-end;
  align-items: center;

  svg {
    width: 254.525px;
    height: 236.222px;
  }

  @media (max-width: 900px) {
    padding: 0;
    height: auto;
    justify-content: center;

    svg {
      width: 180px;
      height: auto;
    }
  }
`;

const RightBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 48px;

  @media (max-width: 900px) {
    gap: 32px;
  }
`;

const TextGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;

  @media (max-width: 900px) {
    align-items: center;
  }
`;

const Title = styled.div`
  align-self: stretch;
  color: var(--color-text-text-500, #000c24);
  font-family: 'Noto Sans KR';
  font-size: 32px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: -0.64px;

  @media (max-width: 900px) {
    font-size: 24px;
  }
`;

const HighlightTitle = styled.div`
  color: var(--color-main-main-500, #0b46dd);
  font-family: 'Noto Sans KR';
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
  letter-spacing: -0.64px;

  @media (max-width: 900px) {
    font-size: 24px;
  }
`;

const Description = styled.div`
  text-align: start;
  align-self: stretch;
  color: var(--color-text-text-300, #545c6c);
  font-family: 'Noto Sans KR';
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: -0.32px;

  @media (max-width: 900px) {
    font-size: 14px;
  }
`;

const ApplyButton = styled.button`
  display: flex;
  height: 45px;
  padding: 0px 40px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 8px;
  background: #0b46dd;
  border: none;
  cursor: pointer;

  @media (max-width: 900px) {
    width: 100%;
    padding: 0px 20px;
  }
`;

const ButtonInner = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2px;
`;

const ButtonText = styled.span`
  color: #fff;
  text-align: right;
  font-family: 'Noto Sans KR';
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;
